import {
  Component,
  OnInit,
  OnDestroy,
  inject,
  Output,
  EventEmitter,
  ViewChild,
  ElementRef,
} from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Subscription } from "rxjs";
import { interval } from "rxjs";
import { AppParams } from "src/app/core/models/appParams";
import {
  HpcJobStageNames,
  HpcVMStates,
  JobTypes,
} from "src/app/core/models/globals";
import {
  Job,
  OutputDownloadState,
  OutputDownloadStatus,
} from "src/app/core/models/job";
import { JobsService } from "src/app/core/services/jobs.service";
import { ManageTooltipService } from "src/app/core/services/manage-tooltip.service";
import { SyncConfigService } from "src/app/core/services/sync-config.service";
import { NavigationService } from "../../../../core/services/navigation.service";
import { EnvironmentService } from "../../../../core/services/environment.service";
import { NgxSpinnerService } from "ngx-spinner";
import { DeploymentService } from "../../../../core/services/deployment.service";
@Component({
  selector: "app-job-details",
  templateUrl: "./job-details.component.html",
  styleUrls: ["./job-details.component.scss"],
})
export class JobDetailsComponent implements OnInit, OnDestroy {
  private spinner = inject(NgxSpinnerService);

  job: Job;
  test: string[];
  customTags: string[];
  nodes: string[];
  inFiles: string[];
  depName: string;
  nodeGroup: string = "-";
  batchNode: string = "-";
  designManager: boolean;
  volumeMesh: boolean;
  appPropJson: AppParams;
  tempJobName: string; // temporary job name take for the 1st time during data load
  clickedJobName: string = ""; // this variable contains the name of clicked job
  inputFilesDropDown: boolean = false;
  jobDetailOnClickSub: Subscription; // subscription for getting data of clicked job from Job list in UI
  jobDetailsHttpRequestSub: Subscription; // subscription for outgoing http request
  jobDetailsAutoReloadSub: Subscription; // subscription for autoreload of job details every 20 seconds
  tooltipHtml = "";
  customTagName: string = this.env.envVariables.customTagName;
  cloudType: string =
    this.route.snapshot.params["cloudType"] ||
    this.route.parent.snapshot.params["cloudType"];
  disableRefresh: boolean = false;
  inputFileListArray?: any[];
  selectedInputFile?: string;
  showPodLink: boolean = false;
  @Output() jobUpdated = new EventEmitter<Job>();

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private navService: NavigationService,
    public jobService: JobsService,
    private tooltipJson: ManageTooltipService,
    private syncConfig: SyncConfigService,
    private env: EnvironmentService,
    private depService : DeploymentService
  ) {}

  ngOnInit(): void {
    this.navService.breadcrumbDeployment.subscribe(
      (x) =>
        (this.depName =
          x ||
          this.route.snapshot.params["deploymentName"] ||
          this.route.parent.snapshot.params["deploymentName"])
    );
    let dep = this.depService.getProfileInfoFromSubject(this.depName);
    if (dep?.scheduler.toLowerCase() == "kube") {
      this.showPodLink = true
    }
    this.jobDetailOnClickSub = this.jobService.jobData.subscribe((x) => {
      if (this.jobDetailsHttpRequestSub)
        this.jobDetailsHttpRequestSub.unsubscribe();
      this.spinner.show("jobDetails");
      this.job = null;
      this.tempJobName = x;
      this.loadJobDetails(x);
      this.batchNode = "-";
      this.nodeGroup = "-";
    });
    this.jobDetailsAutoReloadSub = interval(
      this.syncConfig.config.jobs.detailsReqInterval
    ).subscribe((x) => {
      this.loadJobDetails(this.tempJobName);
    });
  }

  ngOnDestroy() {
    if (this.jobDetailOnClickSub) {
      this.jobDetailOnClickSub.unsubscribe();
    }
    if (this.jobDetailsHttpRequestSub) {
      this.jobDetailsHttpRequestSub.unsubscribe();
    }
    if (this.jobDetailsAutoReloadSub) {
      this.jobDetailsAutoReloadSub.unsubscribe();
    }
  }

  redirectTo(name: string) {
    this.router.navigate([name], { relativeTo: this.route });
    this.clickedJobName = name;
    this.navService.sendChildData(this.clickedJobName);
  }

  loadJobDetails(jobName: string) {
    if (jobName) {
      this.jobDetailsHttpRequestSub = this.jobService
        .getJobDetailsForUser(this.depName, jobName)
        .subscribe({
          next: (data) => {
            this.disableRefresh = false;
            this.job = <Job>JSON.parse(JSON.stringify(data));
            this.jobUpdated.emit(this.job);
            this.job.downloadState = GetDownloadString(this.job?.downloadState);
            this.appPropJson = JSON.parse(this.job.appPropJson);
            let jobTagString = this.job.jobTag;
            if (!jobTagString) {
              this.test = [];
            } else {
              this.test = this.job.jobTag.split(",");
            }

            let customTagString = this.job.customTag;
            if (!customTagString) {
              this.customTags = [];
            } else {
              this.customTags = this.job.customTag.split(",");
            }
            this.verifyAppPropData(this.appPropJson);
            this.verifyJobData(this.job);
            this.updateCurrentJobDirectoryPaths(this.job);
            this.spinner.hide("jobDetails");
            this.inputFileListArray = this.job.inputFileList
              .split(",")
              .map((file) => ({ value: file }));
            this.selectedInputFile = this.inputFileListArray[0].value;
          },
          error: (error) => {},
        });
    }
  }

  redirectToPod() {
    let jobName = this.job.name;
    let cloud = "On-premise";
    if (jobName) {
      let url = `/Nodes List/${cloud}/${this.job.deployment}/Pods/${this.job.name}`;
      this.router.navigate([
        `/Nodes List/${cloud}/${this.job.deployment}/Pods/${this.job.name}`,
      ]);
    }
  }

  updateTag(depName: string, jobName: string, jobTags: string) {
    this.jobService.updateJobTags(depName, jobName, jobTags).subscribe(() => {
      this.job.jobTag = jobTags;
    });
  }

  removeTag(event) {
    const tagToRemove = event;
    this.test = this.test.filter((tag) => tag !== tagToRemove);
    const newString = this.test.join(",");
    this.updateTag(this.depName, this.tempJobName, newString);
  }

  addtoTest(event) {
    const tagToAdd = event.target.value.trim();
    if (tagToAdd && !this.test.includes(tagToAdd)) {
      this.test.push(tagToAdd);
      event.target.value = null;
      const newString = this.test.join(",");
      this.updateTag(this.depName, this.tempJobName, newString);
    }
  }

  updateCustomTag(depName: string, jobName: string, customTags: string) {
    this.jobService
      .updateCustomTags(depName, jobName, customTags)
      .subscribe(() => {
        this.job.customTag = customTags;
      });
  }

  removeCustomTag(event) {
    const tagToRemove = event;
    this.customTags = this.customTags.filter((tag) => tag !== tagToRemove);
    const newString = this.customTags.join(",");
    this.updateCustomTag(this.depName, this.tempJobName, newString);
  }

  addtoCustomTags(event) {
    const tagToAdd = event.target.value.trim();
    if (tagToAdd && !this.customTags.includes(tagToAdd)) {
      this.customTags.push(tagToAdd);
      event.target.value = null;
      const newString = this.customTags.join(",");
      this.updateCustomTag(this.depName, this.tempJobName, newString);
    }
  }

  verifyJobData(job: Job) {
    this.jobService.sendJobNode(job.nodelist);
    if (!job?.isLocalStore) {
      this.jobService.sendJobNode("");
    }
    if (
      job.stage == HpcJobStageNames.STAGE_JOB_INIT &&
      job.status == HpcVMStates.STATE_CODE_FAILED
    ) {
      this.job.outputDirectory = "Directory not created.";
      this.job.workDirectory = "Directory not created.";
    }
    if (job?.inputFileList) {
      this.inputFilesDropDown = true;
      this.inFiles = job?.inputFileList.split(",");
    } else {
      this.inputFilesDropDown = false;
    }
    if (job?.nodelist) {
      this.nodes = job?.nodelist.split(",");
      this.batchNode = this.nodes[0];
    }
  }

  getShortContent(content: string, selectElement: HTMLSelectElement): string {
    const ele = document.getElementById("fileInputSelect");
    const maxLength = Math.floor(ele.clientWidth / 9);
    return content.length > maxLength
      ? `...${content.substring(content.length - maxLength, content.length)}`
      : content;
  }

  verifyAppPropData(appProp: AppParams) {
    if (this.appPropJson.JobGenericProperties.NodeGroup != "") {
      this.nodeGroup = this.appPropJson.JobGenericProperties.NodeGroup;
    } else {
      this.nodeGroup = "Default";
    }
    if (this.job.application == JobTypes.Starccm) {
      appProp.StarCCMProperties.ProjectFile
        ? (this.designManager = true)
        : (this.designManager = false);
      appProp.StarCCMProperties.VolumeMesh
        ? (this.volumeMesh = true)
        : (this.volumeMesh = false);
    }
  }

  getTooltip(tooltipOf: string) {
    this.tooltipHtml = null;
    this.tooltipHtml = this.tooltipJson.getTooltipOf("jobs", tooltipOf);
  }

  updateCurrentJobDirectoryPaths(job: Job) {
    this.jobService.updateJobDirectoryPaths({
      syncStorePath: job.outputDirectory,
      workStorePath: job.workDirectory,
    });
  }

  refreshDetails() {
    if (this.disableRefresh) return;
    this.disableRefresh = true;
    this.loadJobDetails(this.tempJobName);
  }

  /* downloadJobDetails() {
    if (!this.job) {
      this.snackBar.open("No action logs available", "Ok", { duration: 5000 });
      return;
    };
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet([this.job]);//converts a DOM TABLE element to a worksheet
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    // save to file 
    XLSX.writeFile(wb, this.tempJobName + '_JobDetail.xlsx');
  }*/
}

function GetDownloadString(outputDownloadStateStr: string): string {
  let downloadState: string = "";
  let outputDownloadState = parseInt(outputDownloadStateStr);
  switch (outputDownloadState) {
    case OutputDownloadState.Disabled:
      downloadState = OutputDownloadStatus.Disabled;
      break;
    case OutputDownloadState.Enabled:
      downloadState = OutputDownloadStatus.Enabled;
      break;
    case OutputDownloadState.InProgress:
      downloadState = OutputDownloadStatus.InProgress;
      break;
    case OutputDownloadState.Completed:
      downloadState = OutputDownloadStatus.Completed;
      break;
    case OutputDownloadState.Failed:
      downloadState = OutputDownloadStatus.Failed;
      break;
    case OutputDownloadState.Cancelled:
      downloadState = OutputDownloadStatus.Cancelled;
      break;
    case OutputDownloadState.Unknown:
    default:
      downloadState = OutputDownloadStatus.Unknown;
      break;
  }
  return downloadState;
}
